import { 
  LayoutDashboard,
  Dumbbell,
  BedDouble,
  Zap
} from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { WearableDataPoint } from "./types";

interface DataTabsProps {
  data: WearableDataPoint['data'];
  renderMetrics: (data: WearableDataPoint['data'], category: string) => React.ReactNode;
}

export function DataTabs({ data, renderMetrics }: DataTabsProps) {
  if (!data) return null;

  return (
    <Tabs defaultValue="overview" className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="overview" className="flex items-center gap-2 transition-colors duration-200">
          <LayoutDashboard className="h-4 w-4" />
          Overview
        </TabsTrigger>
        <TabsTrigger value="strain" className="flex items-center gap-2 transition-colors duration-200">
          <Dumbbell className="h-4 w-4" />
          Strain
        </TabsTrigger>
        <TabsTrigger value="sleep" className="flex items-center gap-2 transition-colors duration-200">
          <BedDouble className="h-4 w-4" />
          Sleep
        </TabsTrigger>
        <TabsTrigger value="recovery" className="flex items-center gap-2 transition-colors duration-200">
          <Zap className="h-4 w-4" />
          Recovery
        </TabsTrigger>
      </TabsList>

      <TabsContent value="overview" className="mt-4 animate-in fade-in-50 duration-500">
        {renderMetrics(data, 'overview')}
      </TabsContent>

      <TabsContent value="strain" className="mt-4 animate-in fade-in-50 duration-500">
        {renderMetrics(data, 'strain')}
      </TabsContent>

      <TabsContent value="sleep" className="mt-4 animate-in fade-in-50 duration-500">
        {renderMetrics(data, 'sleep')}
      </TabsContent>

      <TabsContent value="recovery" className="mt-4 animate-in fade-in-50 duration-500">
        {renderMetrics(data, 'recovery')}
      </TabsContent>
    </Tabs>
  );
}